module.exports = __webpack_public_path__ + "media/images/steps/step_3-5397e643b4059a2e7c2f15ff27b789b5.svg";